<template>
  <svg @click="removeItem(index)" viewBox="0 0 32 32" :class="[svgClassName, 'select-none']"><title>Ukloni proizvod</title><path fill="currentColor" d="M12 12h2v12h-2zM18 12h2v12h-2z"/><path fill="currentColor" d="M4 6v2h2v20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8h2V6zm4 22V8h16v20zM12 2h8v2h-8z"/></svg>
</template>




<script>

import accounting from "accounting";

export default {
    name: "RemoveIcon",
    props: [
        'index',
        'svgClassName',
	      'product'
    ],
    methods: {

	    /**
	     * Remove product from Shopping cart by sending request to backend.
	     *
	     * @param index
	     */
	    removeItem(index) {

		    axios.post('/izbaci-iz-korpe/' + index)
			    .then(response => {

				    // Preview message
				    this.$toasted.global.toastSuccess({ message: response.data.message });

				    // Update vuex store
				    this.$store.dispatch('Cart/changeCartItems', response.data.cartItems);
				    this.$store.dispatch('Cart/changeItemCount', response.data.cartItemsCount);
				    this.$store.dispatch('Cart/changeTotalPrice', response.data.totalPrice);
				    this.$store.dispatch('Cart/changeSubtotalPrice', response.data.subtotalPrice);
			    })
			    .catch(e => {

			    })

		    console.log(this.product.options.movem_id, this.product.name);

		    dataLayer.push({ecommerce: null});  // Clear the previous ecommerce object.
		    dataLayer.push({
			    event: "remove_from_cart",
			    ecommerce: {
				    currency: "RSD",
				    value: this.formatPrice(this.product.options.final_price),
				    items: [
					    {
						    item_name: this.product.name,
						    item_id: this.product.options.movem_id,
						    item_brand: this.product.options.brend,
						    price: this.formatPrice(this.product.options.final_price),
						    quantity: 1
					    }
				    ]
			    }
		    });
	    },

	    getCategoriesForFeed() {
		    if (this.product.categories_for_feed) {
			    this.product.categories_for_feed.forEach(function (value, i) {
				    'item_category' + (i + 1) + ':' + value;
			    })
		    }
	    },

	    /**
	     * Format price.
	     *
	     * @param value
	     */
	    formatPrice(value) {

		    return accounting.formatMoney(value, '', 2, '', '.')
	    },
    }
}
</script>
